import { Plan } from './types';

// FIXME: Once the complete biomarker list is available, store the complete list in an separate array and index the biomarkers.

const TEST_PANEL_PLANS: readonly Plan[] = [
  {
    key: 'essential',
    title: 'Essential plan',
    panelHeader: '60+ Biomarkers. 8 Health Panels.',
    panels: [
      // === ENABLED PANELS (8) ===
      {
        label: 'Metabolic Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/MetabolicHealth.png',
        availableBiomarkers: ['Fasting Glucose', 'General Insulin', 'HbA1c'],
        unavailableBiomarkers: [],
      },
      {
        label: 'Cardiovascular Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/CardiovascularHealth.png',
        availableBiomarkers: [
          'Triglycerides',
          'Total Cholesterol',
          'HDL Cholesterol',
          'LDL Cholesterol',
          'Total Cholesterol/HDL Ratio',
          'Non-HDL Cholesterol',
          'Homocysteine',
          'Hs-CRP',
        ],
        unavailableBiomarkers: ['Lipoprotein (a)', 'Apolipoprotein B'],
      },
      {
        label: 'Blood Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/BloodHealth.png',
        availableBiomarkers: [
          'White Blood Cell Count',
          'RBC Count',
          'Hemoglobin',
          'Hematocrit',
          'Mean Corpuscular Volume',
          'Mean Corpuscular Hemoglobin',
          'Mean Corpuscular Hemoglobin Concentration',
          'Red Cell Distribution Width',
          'Platelet Count',
          'Mean Platelet Volume',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Immune Regulation',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/ImmuneRegulation.png',
        availableBiomarkers: [
          'Neutrophils',
          'Band Neutrophils %',
          'Absolute Band Neutrophils',
          'Metamyelocytes %',
          'Absolute Metamyelocytes',
          'Myelocytes %',
          'Absolute Myelocytes',
          'Absolute Neutrophil Count',
          'Lymphocytes',
          'Variant Lymphocytes %',
          'Absolute Lymphocyte Count',
          'Monocytes',
          'Absolute Monocyte Count',
          'Eosinophils',
          'Absolute Eosinophil Count',
          'Basophils',
          'Absolute Basophil Count',
          'Blast Cell Absolute Count',
          'Nucleated RBCs per 100 WBCs',
          'Nucleated RBCs Absolute Count',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Thyroid Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/Thyroid.png',
        availableBiomarkers: ['TSH'],
        unavailableBiomarkers: [
          'Free T3',
          'Free T4',
          'Thyroglobulin Antibodies',
          'Anti-TPO',
        ],
      },
      {
        label: 'Kidney Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/KidneyHealth.png',
        availableBiomarkers: [
          'Blood Urea Nitrogen',
          'Serum Creatinine',
          'BUN/Creatinine Ratio',
          'eGFR',
          'Sodium',
          'Potassium',
          'Chloride',
          'Carbon Dioxide',
          'Uric Acid',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Liver Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/LiverHealth.png',
        availableBiomarkers: [
          'Total Bilirubin',
          'Alkaline Phosphatase',
          'SGOT',
          'SGPT',
          'Total Protein',
          'Albumin',
          'Globulin',
          'Albumin/Globulin Ratio',
        ],
        unavailableBiomarkers: ['GGT'],
      },
      {
        label: 'Nutrients',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/Nutrients.png',
        availableBiomarkers: ['Calcium', 'Vitamin D'],
        unavailableBiomarkers: [
          'Magnesium RBC',
          'Zinc',
          'Uric Acid',
          'Methylmalonic Acid',
        ],
      },
      // === DISABLED PANELS (9) ===
      {
        label: 'Advanced Lipid Analysis',
        available: false,
        imageUrl: 'web_v2/blood-vision/test-badges/AdvancedLipidAnalysis.png',
        availableBiomarkers: [],
        unavailableBiomarkers: [
          'LDL Particle Number',
          'LDL Small Particle Number',
          'LDL Particle Size',
          'HDL Particle Number',
          'HDL Large',
          'HDL Size',
          'Large VLDL Particle Number',
          'VLDL Particle Size',
        ],
      },
      {
        label: 'Inflammation',
        available: false,
        imageUrl: 'web_v2/blood-vision/test-badges/Inflammation.png',
        availableBiomarkers: [],
        unavailableBiomarkers: ['Hs-CRP', 'Homocysteine'],
      },
      {
        label: 'Hormone Health',
        available: false,
        imageUrl: 'web_v2/blood-vision/test-badges/HormoneHealth.png',
        availableBiomarkers: [],
        unavailableBiomarkers: [
          'Cortisol',
          'Testosterone - Total',
          'Testosterone - Free',
          'SHBG',
          'DHEAS',
          'Estradiol',
          'Follicle Stimulating Hormone',
          'Lutenizing Hormone',
          'Prolactin',
          'Anti Mullerien Hormone',
          'Leptin',
        ],
      },
      {
        label: 'Iron Status',
        available: false,
        imageUrl: 'web_v2/blood-vision/test-badges/IronStatus.png',
        availableBiomarkers: [],
        unavailableBiomarkers: [
          'Total Iron',
          'TIBC',
          'Transferrin Saturation',
          'Ferritin',
        ],
      },
      {
        label: 'Pancreatic Health',
        available: false,
        imageUrl: 'web_v2/blood-vision/test-badges/PancreaticHealth.png',
        availableBiomarkers: [],
        unavailableBiomarkers: ['Amylase', 'Lipase'],
      },
      {
        label: 'Omega Fatty Acids',
        available: false,
        imageUrl: 'web_v2/blood-vision/test-badges/OmegaFattyAcids.png',
        availableBiomarkers: [],
        unavailableBiomarkers: [
          'EPA + DPA + DHA',
          'Arachidonic Acid/EPA Ratio',
          'Omega-6/Omega-3 Ratio',
          'Omega-3 Total',
          'EPA %',
          'DPA %',
          'DHA %',
          'Omega-6 Total',
          'Arachidonic Acid',
          'Linoleic Acid',
        ],
      },
      {
        label: 'Heavy Metals',
        available: false,
        imageUrl: 'web_v2/blood-vision/test-badges/HeavyMetals.png',
        availableBiomarkers: [],
        unavailableBiomarkers: ['Mercury', 'Lead'],
      },
      {
        label: 'Autoimmunity',
        available: false,
        imageUrl: 'web_v2/blood-vision/test-badges/Autoimmunity.png',
        availableBiomarkers: [],
        unavailableBiomarkers: ['RA Factor'],
      },
      {
        label: 'Urine Analysis',
        available: false,
        imageUrl: 'web_v2/blood-vision/test-badges/Urine.png',
        availableBiomarkers: [],
        unavailableBiomarkers: [
          'Urine Specific Gravity',
          'Urine pH',
          'Urine WBC',
          'Urine RBC',
          'Squamous Epithelial Cells',
          'Transitional Epithelial Cells',
          'Renal Epithelial Cells',
          'Amorphous Sediment',
          'Yeast',
          'Calcium Oxalate Crystals',
          'Triple Phosphate Crystals',
          'Uric Acid Crystals',
          'Hyaline Cast',
          'Granular Casts',
          'Urinary Casts',
          'Glucose (Urine)',
          'Protein (Urine)',
          'Nitrite (Urine)',
          'Ketone (Urine)',
          'Bilirubin (Urine)',
          'Blood (Urine)',
        ],
      },
    ],
  },
  {
    key: 'comprehensive',
    title: 'Annual Plan',
    panelHeader: '100+ Biomarkers. 17 Health Panels.',
    panels: [
      {
        label: 'Metabolic Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/MetabolicHealth.png',
        availableBiomarkers: ['Fasting Glucose', 'General Insulin', 'HbA1c'],
        unavailableBiomarkers: [],
      },
      {
        label: 'Cardiovascular Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/CardiovascularHealth.png',
        availableBiomarkers: [
          'Triglycerides',
          'Total Cholesterol',
          'HDL Cholesterol',
          'LDL Cholesterol',
          'Total Cholesterol/HDL Ratio',
          'Non-HDL Cholesterol',
          'Lipoprotein (a)',
          'Apolipoprotein B',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Blood Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/BloodHealth.png',
        availableBiomarkers: [
          'White Blood Cell Count',
          'RBC Count',
          'Hemoglobin',
          'Hematocrit',
          'Mean Corpuscular Volume',
          'Mean Corpuscular Hemoglobin',
          'Mean Corpuscular Hemoglobin Concentration',
          'Red Cell Distribution Width',
          'Platelet Count',
          'Mean Platelet Volume',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Immune Regulation',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/ImmuneRegulation.png',
        availableBiomarkers: [
          'Neutrophils',
          'Band Neutrophils %',
          'Absolute Band Neutrophils',
          'Metamyelocytes %',
          'Absolute Metamyelocytes',
          'Myelocytes %',
          'Absolute Myelocytes',
          'Absolute Neutrophil Count',
          'Lymphocytes',
          'Variant Lymphocytes %',
          'Absolute Lymphocyte Count',
          'Monocytes',
          'Absolute Monocyte Count',
          'Eosinophils',
          'Absolute Eosinophil Count',
          'Basophils',
          'Absolute Basophil Count',
          'Blast Cell Absolute Count',
          'Nucleated RBCs per 100 WBCs',
          'Nucleated RBCs Absolute Count',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Thyroid Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/Thyroid.png',
        availableBiomarkers: [
          'TSH',
          'Free T3',
          'Free T4',
          'Thyroglobulin Antibodies',
          'Anti-TPO',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Kidney Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/KidneyHealth.png',
        availableBiomarkers: [
          'Blood Urea Nitrogen',
          'Serum Creatinine',
          'eGFR',
          'Sodium',
          'Potassium',
          'Chloride',
          'Carbon Dioxide',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Liver Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/LiverHealth.png',
        availableBiomarkers: [
          'Total Bilirubin',
          'Alkaline Phosphatase',
          'SGOT',
          'SGPT',
          'GGT',
          'Total Protein',
          'Albumin',
          'Globulin',
          'Albumin/Globulin Ratio',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Nutrients',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/Nutrients.png',
        availableBiomarkers: [
          'Calcium',
          'Magnesium RBC',
          'Zinc',
          'Uric Acid',
          'Vitamin D',
          'Methylmalonic Acid',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Advanced Lipid Analysis',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/AdvancedLipidAnalysis.png',
        availableBiomarkers: [
          'LDL Particle Number',
          'LDL Small Particle Number',
          'LDL Particle Size',
          'HDL Particle Number',
          'HDL Large',
          'HDL Size',
          'Large VLDL Particle Number',
          'VLDL Particle Size',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Inflammation',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/Inflammation.png',
        availableBiomarkers: ['Hs-CRP', 'Homocysteine'],
        unavailableBiomarkers: [],
      },
      {
        label: 'Hormone Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/HormoneHealth.png',
        availableBiomarkers: [
          'Cortisol',
          'Testosterone - Total',
          'Testosterone - Free',
          'SHBG',
          'DHEAS',
          'Estradiol',
          'Follicle Stimulating Hormone',
          'Lutenizing Hormone',
          'Prolactin',
          'Anti Mullerien Hormone',
          'Leptin',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Iron Status',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/IronStatus.png',
        availableBiomarkers: [
          'Total Iron',
          'TIBC',
          'Transferrin Saturation',
          'Ferritin',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Pancreatic Health',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/PancreaticHealth.png',
        availableBiomarkers: ['Amylase', 'Lipase'],
        unavailableBiomarkers: [],
      },
      {
        label: 'Omega Fatty Acids',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/OmegaFattyAcids.png',
        availableBiomarkers: [
          'EPA + DPA + DHA',
          'Arachidonic Acid/EPA Ratio',
          'Omega-6/Omega-3 Ratio',
          'Omega-3 Total',
          'EPA %',
          'DPA %',
          'DHA %',
          'Omega-6 Total',
          'Arachidonic Acid',
          'Linoleic Acid',
        ],
        unavailableBiomarkers: [],
      },
      {
        label: 'Heavy Metals',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/HeavyMetals.png',
        availableBiomarkers: ['Mercury', 'Lead'],
        unavailableBiomarkers: [],
      },
      {
        label: 'Autoimmunity',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/Autoimmunity.png',
        availableBiomarkers: ['RA Factor'],
        unavailableBiomarkers: [],
      },
      {
        label: 'Urine Analysis',
        available: true,
        imageUrl: 'web_v2/blood-vision/test-badges/Urine.png',
        availableBiomarkers: [
          'Urine Specific Gravity',
          'Urine pH',
          'Urine WBC',
          'Urine RBC',
          'Squamous Epithelial Cells',
          'Transitional Epithelial Cells',
          'Renal Epithelial Cells',
          'Amorphous Sediment',
          'Yeast',
          'Calcium Oxalate Crystals',
          'Triple Phosphate Crystals',
          'Uric Acid Crystals',
          'Hyaline Cast',
          'Granular Casts',
          'Urinary Casts',
          'Glucose (Urine)',
          'Protein (Urine)',
          'Nitrite (Urine)',
          'Ketone (Urine)',
          'Bilirubin (Urine)',
          'Blood (Urine)',
        ],
        unavailableBiomarkers: [],
      },
    ],
  },
];

const PLANS = [
  {
    key: 'essential',
    title: 'Essential Plan',
    subtitle:
      '60+ biomarkers test with Blood Age, Clinician Summary and Supplement Report.',
    price: '$99',
    perYear: ' every 6 months',
    list: [
      { label: 'Foundational Test (60+ biomarkers)', available: true },
      { label: 'Follow-up test', available: false },
      { label: 'Clinical Summary with Supplement Report', available: true },
      { label: 'Blood Age', available: true },
    ],
  },
  {
    key: 'comprehensive',
    title: 'Annual Plan',
    subtitle:
      'Comprehensive 100+ biomarker blood and urine test, plus a 60+ biomarker follow-up test, with Advanced Blood Age, Clinician Summary and Supplement Report',
    price: '$499',
    perYear: ' anually',
    list: [
      { label: 'Comprehensive Annual Test (100+ biomarkers)', available: true },
      { label: 'Follow-up test (60+ biomarkers)', available: true },
      { label: 'Clinician Summary and Supplement Report', available: true },
      { label: 'Advanced Blood Age', available: true },
    ],
  },
] as const;

export { TEST_PANEL_PLANS, PLANS };
